import { Component } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { BaseModalComponent } from '../base-modal.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { Controller } from '../../../../../coverpath-client/public/js/Controller';
import { FormService } from '../../../services/form/form.service';

@Component({
  templateUrl: './edit-signer-name.component.html',
})
export class EditSignerNameComponent extends BaseModalComponent {
  controller: Controller;

  constructor(
    private amorphicService: AmorphicService,
    protected modalService: ModalService,
    private formService: FormService
  ) {
    super(modalService);
    this.controller = this.amorphicService.controller as Controller;
  }

  cancel() {
    this.resetSignerDetails();
    this.modalService.deactivate();
  }

  confirm() {
    this.resetSignerDetails();
    this.modalService.deactivate();
  }

  resetSignerDetails() {
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insured.signer.firstName', '');
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insured.signer.middleName', '');
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insured.signer.lastName', '');
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insured.hasSigner', undefined);
  }
}
